<div class="w-64  hover:shadow-3xl-up hover:-translate-y-1
    overflow-hidden relative  rounded-3xl
    m-2.5 duration-300 shadow-3xl">
  <div *ngIf="comingSoon" class="ribbon ribbon-top-right">
    <span> Тун удахгүй</span>
  </div>
  <ng-container *ngIf="!comingSoon; else content">
    <a class="no-underline text-black
         " [routerLink]="isPath ? '/path/' + id : '/course/' + id">
      <ng-container *ngTemplateOutlet="content"></ng-container>
    </a>
  </ng-container>
</div>

<ng-template #content>
  <img [src]="imageSource" class="h-40 w-full rounded-3xl" alt="">
  <div class="flex flex-col min-h-[12.5rem] p-3 justify-between ">
    <div>
      <div *ngIf="!isPath" >
        <!-- <div class="
              teacherImage">
              <img [src]="teacherImageSource">
          </div> -->
        <div class=" teacherTitle italic  text-black">{{teacherTitle}}</div>
        <div class="teacherName text-base font-medium text-black">{{teacherName}}</div>
      </div>
  
      <div class="courseName text-lg  font-bold text-black ">{{name}}</div>
  
      <div *ngIf="isPath" >
        <!-- <div class="
              teacherImage">
              <img [src]="teacherImageSource">
          </div> -->
        <div class="teacherTitle italic text-xs text-black">Хичээлийн тоо: {{courseCount}}</div>
      </div>
    </div>
  
      <div *ngIf="paid">
        <mat-chip-list aria-label="Fish selection">
          <mat-chip color="warn" selected>Баталгаажаагүй</mat-chip>
        </mat-chip-list>
      </div>
      <div>
        <div class="flex flex-row justify-between">
          <div [ngSwitch]="difficulty">
            <ng-container *ngSwitchCase="'beginner'">
              <svg width="38" height="10" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill="#E5E5E5" d="M9 4h6v2H9zM23 4h6v2h-6z"></path>
                <circle cx="5" cy="5" r="4" fill="#003757" stroke="#003757" stroke-width="2"></circle>
                <circle cx="19" cy="5" r="4" fill="#E5E5E5" stroke="#E5E5E5" stroke-width="2"></circle>
                <circle cx="33" cy="5" r="4" fill="#E5E5E5" stroke="#E5E5E5" stroke-width="2"></circle>
              </svg>
              <div class="difficulty text-xs text-black	">
                Анхан шат
              </div>
            </ng-container>
            <ng-container *ngSwitchCase="'intermediate'">
              <svg width="38" height="10" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill="#003757" d="M9 4h6v2H9z">
                </path>
                <path fill="#E5E5E5" d="M23 4h6v2h-6z">
                </path>
                <circle cx="5" cy="5" r="4" fill="#003757" stroke="#003757" stroke-width="2">
                </circle>
                <circle cx="19" cy="5" r="4" fill="#003757" stroke="#003757" stroke-width="2">
                </circle>
                <circle cx="33" cy="5" r="4" fill="#E5E5E5" stroke="#E5E5E5" stroke-width="2">
                </circle>
              </svg>
              <div class="difficulty text-xs text-black	">
                Дунд шат
              </div>
            </ng-container>
            <ng-container *ngSwitchCase="'advanced'">
              <svg width="38" height="10" viewBox="0 0 38 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill="#003757" d="M9 4h6v2H9zM23 4h6v2h-6z"></path>
                <circle cx="5" cy="5" r="4" fill="#003757" stroke="#003757" stroke-width="2"></circle>
                <circle cx="19" cy="5" r="4" fill="#003757" stroke="#003757" stroke-width="2"></circle>
                <circle cx="33" cy="5" r="4" fill="#003757" stroke="#003757" stroke-width="2"></circle>
              </svg>
              <div class="difficulty text-xs text-black	">
                Ахлах шат
              </div>
            </ng-container>
            <ng-container *ngSwitchCase="'all'">
              <svg width="38" height="10" viewBox="0 0 38 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill="#E5E5E5" d="M9 4h6v2H9zM23 4h6v2h-6z"></path>
                <circle cx="5" cy="5" r="4" fill="#E5E5E5" stroke="#E5E5E5" stroke-width="2"></circle>
                <circle cx="19" cy="5" r="4" fill="#E5E5E5" stroke="#E5E5E5" stroke-width="2"></circle>
                <circle cx="33" cy="5" r="4" fill="#E5E5E5" stroke="#E5E5E5" stroke-width="2"></circle>
              </svg>
              <div class="difficulty text-xs text-black	">
                Бүх шат
              </div>
    
            </ng-container>
          </div>
          <div class=" text-black text-lg font-bold price">
            {{price | tugrug}}
          </div>
        </div>
      </div>
  </div>
</ng-template>
